<template>
    <v-card class="ma-4 px-4" style="height: calc(100% - 36px);" outlined :loading="loading">
        <v-card-title>
            <v-icon class="mr-2">mdi-view-list</v-icon>
            Article List
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mr-2" :to="'/admin/article'">
                <v-icon left>mdi-plus</v-icon>
                Add
            </v-btn>
            <v-btn color="grey" dark>
                <v-icon left>mdi-trash-can</v-icon>
                To Trash
            </v-btn>
        </v-card-title>
        <v-data-table :headers="headers" :items="articleList" :items-per-page="20" item-key="ID" show-select>
            <template v-slot:item.StateIcon="{ item }">
                <v-icon>{{ getIcon(item.State) }}</v-icon>
            </template>
            <template v-slot:item.Control="{ item }">
                <v-btn icon color="primary" :to="'/admin/article/' + item.IDStr">
                    <v-icon>mdi-file-document-edit</v-icon>
                </v-btn>
                <v-btn icon color="grey" @click="showDeleteDialog(item)">
                    <v-icon>mdi-trash-can</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="deleteDialogShow" max-width="500">
            <v-card>
                <v-card-title class="headline warning lighten-2 mb-4">Move Article to Trash?</v-card-title>
                <v-card-text class="subtitle-1 black--text"> The Article: {{ willDeleteArticle.Title }}<br />Will be moved to Trash, Sure?</v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" text @click="deleteDialogShow = false">
                        No
                    </v-btn>
                    <v-btn color="warning" text @click="deleteArticle()">
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { apiGetArticles, apiDeleteArticle } from "../../api/article";
import { Log } from "../../utils/debug";

export default {
    name: "ArticleList",
    data: () => ({
        loading: true,
        deleteDialogShow: false,
        willDeleteArticle: {},
        headers: [
            {
                text: "Title",
                align: "left",
                sortable: false,
                value: "Title"
            },
            { text: "State", value: "StateIcon" },
            { text: "Comments", value: "CommentCount" },
            { text: "Views", value: "ViewCount" },
            { text: "Control", value: "Control", align: "end" }
        ],
        articleList: []
    }),
    mounted() {
        apiGetArticles()
            .then(resp => {
                Log.debug(resp);
                this.articleList = resp.data;
                this.loading = false;
            })
            .catch(err => {
                Log.error(err);
            });
    },
    methods: {
        getIcon: state => {
            if (state === 1) {
                return "mdi-file-document-box-check";
            } else if (state === 0) {
                return "mdi-circle-edit-outline";
            } else if (state === -1) {
                return "mdi-trash-can";
            }
        },
        showDeleteDialog: function(item) {
            Log.debug(item);
            this.willDeleteArticle = item;
            this.deleteDialogShow = true;
        },
        deleteArticle: function() {
            let that = this;
            apiDeleteArticle(this.willDeleteArticle.IDStr, "trash").then(() => {
                let index = 0;
                for (index = 0; index < that.articleList.length; index++) {
                    if (that.articleList[index].IDStr === that.willDeleteArticle.IDStr) {
                        break;
                    }
                }
                that.articleList.splice(index, 1);
                this.deleteDialogShow = false;
            });
        }
    }
};
</script>

<style scoped></style>
